import { motion } from "framer-motion";
import { Award, GraduationCap, BadgeCheck } from "lucide-react";
import { fadeUp, fadeUpChild, stagger, viewportOnce } from "./anim";
import { awards, education, certifications } from "@/data/resume";

export const Recognition = () => {
  return (
    <section
      data-testid="recognition"
      className="relative mx-auto max-w-[1500px] px-6 py-24 md:px-12 md:py-36"
    >
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        className="mb-16"
      >
        <span className="font-mono-x text-xs uppercase tracking-[0.3em] text-[#9A7526]">
          (06) — Recognition
        </span>
        <h2 className="mt-6 font-display text-4xl font-light tracking-tight text-[#1A1A18] md:text-6xl">
          Awards, education & credentials.
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-12">
        {/* Awards */}
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="lg:col-span-7"
        >
          <div className="mb-8 flex items-center gap-3">
            <Award size={16} className="text-[#9A7526]" />
            <span className="font-mono-x text-[11px] uppercase tracking-[0.25em] text-[#6E6D66]">
              Awards
            </span>
          </div>
          <div className="space-y-px overflow-hidden border border-black/10 bg-black/10">
            {awards.map((a, i) => (
              <motion.div
                key={i}
                variants={fadeUpChild}
                data-testid={`award-${i}`}
                className="bg-[#FFFFFF] p-8"
              >
                <div className="font-mono-x text-[11px] uppercase tracking-[0.2em] text-[#9A7526]">
                  {a.org}
                </div>
                <h3 className="mt-2 font-display text-2xl font-light text-[#1A1A18]">
                  {a.title}
                </h3>
                <p className="mt-3 font-body text-sm font-light leading-relaxed text-[#6E6D66]">
                  {a.detail}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Education + certs */}
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="lg:col-span-5"
        >
          <div className="mb-8 flex items-center gap-3">
            <GraduationCap size={16} className="text-[#9A7526]" />
            <span className="font-mono-x text-[11px] uppercase tracking-[0.25em] text-[#6E6D66]">
              Education
            </span>
          </div>
          <div className="space-y-6">
            {education.map((e, i) => (
              <motion.div
                key={i}
                variants={fadeUpChild}
                data-testid={`education-${i}`}
                className="border-l border-black/10 pl-5"
              >
                <div className="font-body text-lg font-medium text-[#1A1A18]">
                  {e.degree}
                </div>
                <div className="mt-1 font-body text-sm font-light text-[#6E6D66]">
                  {e.school} · {e.year}
                </div>
                <div className="mt-1 font-mono-x text-[11px] uppercase tracking-[0.15em] text-[#9A7526]">
                  {e.note}
                </div>
              </motion.div>
            ))}
          </div>

          <div className="mb-6 mt-12 flex items-center gap-3">
            <BadgeCheck size={16} className="text-[#9A7526]" />
            <span className="font-mono-x text-[11px] uppercase tracking-[0.25em] text-[#6E6D66]">
              Certifications
            </span>
          </div>
          <ul className="space-y-3">
            {certifications.map((c) => (
              <motion.li
                key={c}
                variants={fadeUpChild}
                className="font-body text-sm font-light leading-relaxed text-[#6E6D66]"
              >
                {c}
              </motion.li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};
